import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchUserPasswordRequest = {
	currentPassword: string;
	desiredPassword: string;
};

export const patchUserPassword = createPatchEndpoint<PatchUserPasswordRequest>(
	'/api/v3/core/users/current/change-pass'
);
